function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { fetchShop } from "../../shop/async";
import VideoGrid from "../interstellar/video-grid";
var $containerSelector = ".js-listingContainer";
var $bodySelector = ".js-listingBody";
var $nextButton = $(".js-listingLoadMore");
var limitReached = false;
var listing = {
  init: function init() {
    if ($($containerSelector).length === 0) return;
    $nextButton.on("click", function (e) {
      e.preventDefault();
      if (limitReached) return;
      if (e.currentTarget) {
        var $this = $(e.currentTarget);
        var currentPaging = $this.data("href");
        var nextPage = parseInt(currentPaging.replace("page/", ""), 10) + 1;
        $this.data("href", "page/".concat(nextPage));
        listing.fetch(true, currentPaging, nextPage, $this);
      }
    });
  },
  fetch: function fetch() {
    var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var uri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page/1";
    var nextPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    var btn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var targetContainer = btn.closest($containerSelector);
    var listingBody = targetContainer.find($bodySelector);
    if (listingBody.length === 0) return;
    var listingData = listingBody.data("filters");
    var param = [];
    var filter = [];
    var postType = "";
    var endpoint = "cpt_paging";
    if (listingData.endpoint) {
      endpoint = listingData.endpoint;
    }
    if (listingData.type) {
      postType = listingData.type;
      filter.push(listingData.type);
    }
    if (listingData.category) {
      filter.push(listingData.category);
    } else {
      filter.push("all");
    }
    if (listingData.param && _typeof(listingData.param) === "object") {
      param = Object.keys(listingData.param).map(function (item) {
        return "".concat(item, "=").concat(listingData.param[item]);
      });
    }
    btn.addClass("is-loading");
    fetchShop("".concat(endpoint, "/").concat(filter.join("/"), "/").concat(uri), "?".concat(param.join("&"))).then(function (posts) {
      if (append) {
        listingBody.append(posts.html);
      } else {
        listingBody.html(posts.html);
      }
      if (postType === "video") {
        window.VideoGrid.dynamicInit();
      }
      if (nextPage > posts.limit) {
        btn.hide();
        limitReached = true;
      } else {
        btn.show();
      }
      btn.removeClass("is-loading");
    }).catch(function (error) {
      if (error.status === 404) {
        if (!append) listingBody.html("");
        btn.removeClass("is-loading");
      }
    });
  },
  finalize: function finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};
export default listing;


// WEBPACK FOOTER //
// ./scripts/components/interstellar/listing.js